import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '@crosscutting/public_api';
import { environment } from '../../environments/environment';

import { VMModulesResponse, VMModulesContentResponse, VMFinishedModuleResponse, vmResultResponse } from '../../vm_models';

@Injectable()
export class VeiligheidsMeterService {
  constructor(private _http: HttpService) { }

  prefetch(): Observable<string> {
    return this._http.prefetch();
  }

  /* Retrieves all modules available for this check */
  getAvailableVMModules(): Observable<VMModulesResponse> {
    return this._http.get<VMModulesResponse>(environment.availableVMModulesUrl);
  }
  
  getModuleResults(id: string, key: string): Observable<vmResultResponse> {
    const input = {
      veiligheidsmeterId: id,
      key: key
    };

    return this._http.post<any>(environment.vmGetScore, input);
  }

  getModuleVMContent(moduleKey: string): Observable<VMModulesContentResponse> {
    const input = {
      key: moduleKey
    };

    return this._http.post<VMModulesContentResponse>(environment.vmModuleUrl, input);
  }

  sendFinishedModule(vmID: string, moduleID: string, selectedAnswers): Observable<VMFinishedModuleResponse> {
    let reqObj = new Object({
      "veiligheidsmeter": {
        "id": vmID ? vmID : '',
        "ingevuldeModules": [
          {
            "id": moduleID,
            "geselecteerdeAntwoorden": selectedAnswers
          }
        ]
      }
    })

    return this._http.post<any>(environment.vmStoreVMUrl, reqObj);
  }
}
